module.exports = __webpack_public_path__ + "media/images/Reboot-icon-fda18b83d558cac6340136d393cea44a.svg";